/* eslint-disable max-len */
import 'react';

const DemoModeSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><g transform="translate(5 6)"><rect stroke="#5C6373" strokeWidth="1.5" x=".75" y=".75" width="12.5" height="9.5" rx="2" /><path stroke="#5C6373" strokeWidth="1.5" strokeLinecap="round" d="M3.097 12.5l1-2.218M10.963 12.5l-1-2.218" /><path d="M8.827 5.916L6.478 7.482a.5.5 0 01-.777-.416V3.934a.5.5 0 01.777-.416l2.35 1.566a.5.5 0 010 .832z" fill="#5C6373" /></g><path stroke="#5C6373" strokeWidth="1.5" strokeLinecap="round" d="M8 4.5h7.5" /><path d="M0 0h24v24H0z" /></g></svg>
);

export default DemoModeSvg;
